import { ValuesType } from 'utility-types';
import { GAME_MODE } from '~/interfaces';

export const modeNeedsMultiplePlayers = (mode: ValuesType<typeof GAME_MODE>, tracksCount: number) =>
  tracksCount > 1 && (mode === GAME_MODE.CO_OP || mode === GAME_MODE.PASS_THE_MIC);

export const canStartGameMode = (
  mode: ValuesType<typeof GAME_MODE>,
  tracksCount: number,
  playerCount: number,
  configuredPlayerCount = playerCount,
) => !modeNeedsMultiplePlayers(mode, tracksCount) || (playerCount >= 2 && configuredPlayerCount >= 2);